import { Image } from "antd";
import React from "react";
import sort from "../../assets/img/sort.svg";

const SortIcon = ({ onClick }) => {
  return <Image onClick={onClick} preview={false} src={sort} />;
};

export default SortIcon;
